import { render } from "./HomePage.vue?vue&type=template&id=fb588c82&scoped=true&ts=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=fb588c82&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-speech/democratielab-speech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb588c82"]])

export default __exports__